// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.singlefamilyenterprise.RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts,
  RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { UserSingleFamilyEnterpriseContractsResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_Options = UseQueryOptions<
  UserSingleFamilyEnterpriseContractsResponseWebDto,
  unknown,
  UserSingleFamilyEnterpriseContractsResponseWebDto,
  readonly [string]
>;

const RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_GetKey = () =>
  [RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_Path] as const;

export const RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_GetKey(),
    queryFn: () => RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get active single family enterprise contracts for the user
 */
export const useRentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts.getKey =
  RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_GetKey;
